import { ApolloClient, InMemoryCache } from "@apollo/client"
import * as Sentry from '@sentry/react'
import { onError } from "@apollo/client/link/error"
import { setContext } from "@apollo/client/link/context"
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'
import { navigateOutsideReact } from "@components/NavigationBridge";
import { authService } from "@services"

const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (networkError) {
    console.warn("[Network error caught]", networkError);
    navigateOutsideReact("/network-error")
  }

  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      switch (err.message) {
        case "Unauthenticated.":
          const isVerifyRoute = window.location.pathname === "/verify"

          if (!isVerifyRoute) {
            authService.logout(true)
            window.location.href = "/session-expired"
          }
          
          break
        default:
          Sentry.withScope(function (scope) {
            const queryText = operation?.query?.loc?.source?.body || "Query body unavailable in production";
            scope.setLevel('info')
            scope.setExtra('GraphQL response', JSON.stringify(err))
            scope.setExtra("GraphQL Request Query", queryText);
            scope.setExtra("GraphQL Request Variables", operation?.variables);

            Sentry.captureException(new Error(err.message))
          })
      }
    }
  }
})

const authLink = setContext((_, { headers }) => {
  const token = authService.getToken()

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "X-Referrer": window.location.href,
    },
  }
})

export const cache = new InMemoryCache({
  typePolicies: {
    SessionTimetableBooking: {
      keyFields: ["id", "booking_slot_id"],
    },

    Session: {
      fields: {
        groupLessonStudentCounts: {
          merge(existing, incoming) {
            return incoming;  // Always use incoming data
          },
        },

        groupLessonBookingCounts: {
          merge(existing, incoming) {
            return incoming; // Always use incoming data
          },
        },

        groups: {
          merge(existing, incoming) {
            return incoming; // Always use incoming data 
          },
        },

      },
    },
    Group: {
      fields: {
        lessons: {
          merge(existing, incoming) {
            return incoming; // Always use incoming data
          },
        },
      }
    },
    SbStaffAccount: {
      keyFields: ["client_id", "email"],
    },
  },
})

const apolloClient = new ApolloClient({
  link: authLink.concat(errorLink).concat(uploadLink),
  cache,
})

export default apolloClient
